export const TIME_REGEX_HOURS_MINUTES = /^([0-9]?[0-9]):[0-5][0-9]$/;
export const TIME_MASK_ZEROHOUR_ZEROMINUTES = "00:00";
export const TIME_PLACEHOLDER_HOURS_MINUTES = "hh:mm";
export const TIME_MASK_ZEROHOUR_ZEROMINUTES_24H = "HH:mm";
